export default __webpack_public_path__ + "static/media/profile1.a94fbf17.png";